/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Create_Folder_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enter a name for the new folder. It will be created in the current directory." |
*
* @param {Spaces_Create_Folder_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_create_folder_description = /** @type {((inputs?: Spaces_Create_Folder_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Create_Folder_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib einen Namen für den neuen Ordner ein. Er wird im aktuellen Verzeichnis erstellt.")
	return /** @type {LocalizedString} */ ("Enter a name for the new folder. It will be created in the current directory.")
});